import IModelItem from "./IModelItem";
import {isoToLocalDateString} from "../stores/StoreUtilities";

export enum ReviewItem {
  Questionaire = "Questionaire",
  TaxReturn = "TaxReturn",
  Timeline = "Timeline",
  AssetsAndLiabilities = "AssetsAndLiabilities",
  Budget = "Budget"
}

export class ReviewChecklistItem {
  reviewItem: ReviewItem
  completed: boolean

  constructor (data: any) {
    this.reviewItem = data.reviewItem
    this.completed = data.completed
  }
}

export enum ReviewStatus {
  Pending = "Pending",
  InProgress = "InProgress",
  Submitted = "Submitted",
  Declined = "Declined"
}

class Review implements IModelItem {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  snapshotId: string
  baseSnapId: string
  reviewDate: string
  checklist: ReviewChecklistItem[]
  submittedOn: string
  managed: boolean
  archived: boolean
  status?: ReviewStatus

  constructor (data: any) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.accountId = data.accountId
    this.userId = data.userId
    this.modelId = data.modelId
    this.snapshotId = data.snapshotId
    this.baseSnapId = data.baseSnapId
    this.reviewDate = data.reviewDate
    this.checklist = data.checklist ? JSON.parse(data.checklist) : {}
    this.submittedOn = data.submittedOn
    this.managed = data.managed ?? false
    this.archived = data.archived === true
    if (data.status) {
      this.status = data.status
    } else if (this.submittedOn) {
      this.status = ReviewStatus.Submitted
    } else if (this.updatedAt > this.createdAt) {
      this.status = ReviewStatus.InProgress
    } else {
      this.status = ReviewStatus.InProgress
    }
  }

  getTypename(): string {
    return "Review"
  }

  getReviewTitle() {
    if (this.reviewDate) {
      return `${isoToLocalDateString(this.reviewDate, "MMM d, yyyy")} Review`
    }
    return ""
  }

  isItemCompleted(reviewItem: ReviewItem) {
    const item = this.checklist.find((i: ReviewChecklistItem) => i.reviewItem === reviewItem )
    return (item && item.completed)
  }

  static getDefaultChecklist(managed: boolean): ReviewChecklistItem[] {
    if (managed) {
      return ([
        {reviewItem: ReviewItem.Questionaire, completed: false},
        {reviewItem: ReviewItem.TaxReturn, completed: false},
        {reviewItem: ReviewItem.Timeline, completed: false},
        {reviewItem: ReviewItem.AssetsAndLiabilities, completed: false},
        {reviewItem: ReviewItem.Budget, completed: false},
      ])
    } else {
      return ([
        {reviewItem: ReviewItem.Timeline, completed: false},
        {reviewItem: ReviewItem.AssetsAndLiabilities, completed: false},
        {reviewItem: ReviewItem.Budget, completed: false},
      ])
    }
  }
}

export default Review